import React, { useContext, useEffect, useMemo, useState } from "react";
import FilterSidebar from "../../component/filter-sidebar/FilterSidebar";
import LazyLoadTable from "../../component/table/lazy-load-table/LazyLoadTable";
import { formatDateDTO, formatDateFromDTOCustom, formatDateToDTOCustom } from "../../utils/FormatUtils";
import WfStatusSummary from "../../workflows/components/WfStatusSummary";
import { DSBenhNhanColumns } from "../const/ThuNganColumns";
import { withBarcodeScan } from "@oceantech/oceantech-ui";
import { TYPE_VT } from "../const/ThuNganConstant";
import { searchDSBenhNhan } from "../services/PhanHeThuNganServices";
import { AppContext } from "../../appContext/AppContext";
import "../PhanHeThuNgan.scss";
import { getListWarehouseLv1 } from "../../utils/ServicesUtils";
import AutocompleteObjectV2 from "../../component/AutocompleteObjectV2";
import { Formik } from "formik";
import { Form } from "react-bootstrap";

interface Props {
  searchData: any;
  setSearchData: React.Dispatch<any>;
  summaryStatus: any;
  handleRefreshData: (row: any, isUpdateSummaryStatus?: boolean, isUpdateDsBenhNhan?: boolean) => void;
  selectedRow?: any;
  barcode?: any;
}

const TableDanhSachBenhNhan = (props: Props) => {
  const { searchData, setSearchData, handleRefreshData, barcode = "", summaryStatus, selectedRow } = props;
  const { setIsLoading } = useContext(AppContext);
  const [listData, setListData] = useState([]);
  const [status, setStatus] = useState(null);
  const [lstWarehouse, setLstWarehouse] = useState<any>([]);
  const [warehouse, setWarehouse] = useState<any>();
  const [hasLoaded, setHasLoaded] = useState(false);
  const TYPE_SEARCH = [
    {
      type: TYPE_VT.THUOC,
      value: TYPE_VT.THUOC,
      label: "Thuốc",
    },
    {
      type: TYPE_VT.VAT_TU,
      value: TYPE_VT.VAT_TU,
      label: "Vật tư",
    },
  ];
  const handleChangeSelectWarehouse = (data: any) => {
    setWarehouse(data);
    // setSearchData({})
  };
  const updateListWarehouse = async () => {
    try {
      const data = await getListWarehouseLv1();
      setLstWarehouse(data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    updateListWarehouse();
  }, []);
  useEffect(() => {
    if (!hasLoaded && listData?.length && barcode) {
      handleRefreshData(listData[0]);
      setHasLoaded(true);
    }
  }, [listData]);

  const handleSearch = (data: any) => {
    const convertData = {
      keyword: data.keyword?.trim() || null,
      type: data.typeRadio,
      fromDate: formatDateFromDTOCustom(data.period?.fromDate) || null,
      toDate: formatDateToDTOCustom(data.period?.toDate) || null,
    };
    setSearchData(convertData);
  };

  useEffect(() => {
    searchData?.type && setSearchData({
      ...searchData,
      keyword: barcode,
      slipStatus: status,
      warehouseId: warehouse?.id
    })
  }, [barcode, status, warehouse]);

  const handleSelectedRow = (row: any, index: number | null) => {
    handleRefreshData(row);
  };

  const onClickStatus = (item: any) => {
    setStatus(() => item?.statusCode === status ? null : item?.statusCode)
  }
  return (
    <div className="bangDSBenhNhan position-relative spaces pt-10 gap-8">
      <Formik initialValues={{}} onSubmit={() => { }}>
        <Form>
          <div className="border-left-0 h-calc-300px">
            {/* <div className="flex" > */}
              <div className="flex bg-white spaces width-60 px-12 gap-10 mb-5" >
                <AutocompleteObjectV2
                  options={lstWarehouse}
                  isSearchDefauilt={true}
                  name={"WmsCode"}
                  onChange={(options: any) => handleChangeSelectWarehouse(options)}
                  value={warehouse || ""}
                  className="autocomplete-custom-renderform  radius spaces width-100 h-29"
                  isClearable={true}
                />
              </div>
                <div className="" >
              <FilterSidebar
                onSearch={handleSearch}
                formCheckList={TYPE_SEARCH}
                defaultValueFormCheckList={TYPE_VT.THUOC}
              />
              </div>
            {/* </div> */}
            <LazyLoadTable
              searchData={searchData}
              columns={DSBenhNhanColumns}
              axiosReq={searchDSBenhNhan}
              className="spaces h-calc-vh-280"
              onRowClick={handleSelectedRow}
              idSelected={selectedRow?.id}
              refreshOnRowClick={true}
              setListData={setListData}
            />
          </div>
          <div className="d-flex flex-column spaces w-100 pb-3 gap-5 position-absolute bottom-15">
            <WfStatusSummary summaryStatus={summaryStatus || []} onClick={onClickStatus} />
          </div>
        </Form>
      </Formik>
    </div >
  );
};
// const component = withBarcodeScan(TableDanhSachBenhNhan)
// export { withBarcodeScan(TableDanhSachBenhNhan) };
export default withBarcodeScan(TableDanhSachBenhNhan);

